import { keyframes, styled } from '../stitches';

const fadeInForgotPassword = keyframes({
  '0%': {
    opacity: 0,
  },
  '100%': {
    opacity: 1,
  },
});

const hoverArrow = keyframes({
  '0%': { transform: 'translate(0px, -5px)' },
  '50%': { transform: 'translate(-5px, -5px)' },
  '100%': { transform: 'translate(0px, -5px)' },
});

export const hoverButton = keyframes({
  '0%': { scale: '1.05' },
  '50%': { scale: '1' },
  '100%': { scale: '1.05' },
});

export const Container = styled('div', {
  width: '100%',
  background:
    'linear-gradient(178.86deg, #4521AB 10.17%, rgba(69, 33, 171, 0.92) 27.44%, rgba(69, 33, 171, 0.88) 43.28%, rgba(69, 33, 171, 0.85421) 61.51%, rgba(69, 33, 171, 0.824252) 78.31%, rgba(69, 33, 171, 0.8) 90.78%, rgba(69, 33, 171, 0.74) 99.02%);',
  display: 'flex',
  minHeight: '100vh',
});

export const Wrapper = styled('div', {
  maxWidth: '90rem',
  width: '100%',
  margin: '0 auto',
  display: 'flex',

  minHeight: '100vh',
  padding: '$5',
  animation: `${fadeInForgotPassword} ease-in 0.5s`,
});

export const NextouContainer = styled('div', {
  width: '50%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',

  borderRadius: '0.625rem',

  padding: '3.5rem $12',

  position: 'relative',
  background: '$brightColour',

  'img#logo': {
    width: '8.2625rem',
    height: '2.5656rem',
    position: 'absolute',
    top: '3.5rem',
    left: '2.75rem',
  },

  'img#nextou': {
    maxWidth: '34.5625rem',
    height: '34.8125rem',
    width: '100%',
  },

  p: {
    color: '$texts',
    fontSize: '$xl',
    fontWeight: '$medium',
    lineHeight: '30px',
    maxWidth: '28.4375rem',
    width: '100%',
  },

  '@media (max-width: 920px)': {
    display: 'none',
  },
});

export const ForgotPasswordContainer = styled('div', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',

  width: '50%',

  borderTopRightRadius: '0.625rem',
  borderBottomRightRadius: '0.625rem',

  '@media (max-width: 920px)': {
    minHeight: '100vh',
    width: '100%',
    padding: '0px 1rem',
  },
});

export const ForgotPasswordWrapper = styled(`div`, {
  maxWidth: '21.4375rem',
  width: '100%',
  margin: '0 auto',

  strong: {
    marginTop: '$15',
    fontFamily: 'Poppins',
    fontWeight: 700,
    fontSize: '$2xl',
    color: '$brightColour',
    display: 'block',
  },

  p: {
    marginTop: '$5',
    fontFamily: '$default',
    fontWeight: 400,
    fontSize: '$sm',
    color: '$brightColour',
    display: 'block',
  },
});

export const ForgotPasswordHeader = styled('header', {
  display: 'flex',
  alignItems: 'center',

  img: {
    flex: 1,
  },

  svg: {
    transform: 'translateY(-5px)',
    cursor: 'pointer',
    '&:hover': {
      animation: `${hoverArrow} ease-in 0.5s infinite`,
    },
  },
});

export const ForgotPasswordForm = styled('form', {
  marginTop: '46px',

  div: {
    borderBottom: '1px solid $brightColour',
    paddingBottom: '$1',
    display: 'flex',
    alignItems: 'center',
    gap: '$3',
    position: 'relative',
    width: '100%',

    svg: {
      position: 'absolute',
      left: 0,
    },

    input: {
      height: '1.75rem',
      zIndex: 3,
      width: '100%',
      paddingLeft: '$11',
      background: 'transparent',
      border: 0,
      outline: '0',
      color: '$brightColour',
      fontSize: '$md',
      '&:disabled': {
        cursor: 'not-allowed',
      },
      '&::placeholder': {
        color: '$brightColour',
        fontSize: '$md',
      },
    },
  },

  button: {
    width: '100%',
    height: '2.9975rem',
    borderRadius: '$xl',
    background: '$secondaryButtonBackground',
    border: 0,
    color: '$secondaryButtonColor',
    fontFamily: 'Poppins',
    fontWeight: 600,
    fontSize: '$md',
    marginTop: '$22',
    cursor: 'pointer',
    '&:hover': {
      animation: `${hoverButton} ease-in 0.5s infinite`,
    },

    '&:disabled': {
      cursor: 'not-allowed',
      animation: `${hoverButton} ease-in 0s`,
    },
  },
});
